<script lang="ts">
  import { Wifi, WifiOff, RefreshCw, Cloud, CloudOff, AlertCircle } from 'lucide-svelte';
  import {
    isOnline,
    isSyncing,
    lastSyncTime,
    syncError,
    pendingSyncCount,
    connectionStatus,
    syncService,
  } from '../lib/sync-service';
  import Button from './ui/button.svelte';
  import { _ } from 'svelte-i18n';

  // Format last sync time
  function formatLastSync(timestamp: number | null): string {
    if (!timestamp) return 'Nikdy';

    const now = Date.now();
    const diff = now - timestamp;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return 'Právě teď';
    if (minutes < 60) return `Před ${minutes} min`;
    if (hours < 24) return `Před ${hours} h`;
    return `Před ${days} dny`;
  }

  async function handleManualSync() {
    if (!$isOnline || $isSyncing) return;
    await syncService.forceSyncNow();
  }
</script>

<div class="flex items-center gap-3 text-sm">
  <!-- Online/Offline indicator -->
  <div class="flex items-center gap-1.5">
    {#if $isOnline}
      <Wifi class="w-4 h-4 text-primary" />
    {:else}
      <WifiOff class="w-4 h-4 text-warning" />
    {/if}
    <span class="text-muted-foreground">{$connectionStatus}</span>
  </div>

  <!-- Sync status -->
  {#if $isSyncing}
    <div class="flex items-center gap-1.5 text-primary">
      <RefreshCw class="w-4 h-4 animate-spin" />
      <span>Synchronizuji...</span>
    </div>
  {:else if $syncError}
    <div class="flex items-center gap-1.5 text-destructive">
      <AlertCircle class="w-4 h-4" />
      <span>Chyba synchronizace</span>
    </div>
  {:else if $pendingSyncCount > 0}
    <div class="flex items-center gap-1.5 text-warning">
      <CloudOff class="w-4 h-4" />
      <span>{$pendingSyncCount} nesynchronizováno</span>
    </div>
  {:else if $isOnline}
    <div class="flex items-center gap-1.5 text-green-600">
      <Cloud class="w-4 h-4" />
      <span class="text-muted-foreground">
        {formatLastSync($lastSyncTime)}
      </span>
    </div>
  {/if}

  <!-- Manual sync button -->
  {#if $isOnline && !$isSyncing}
    <Button
      onclick={handleManualSync}
      variant="ghost"
      size="sm"
      class="h-8 px-2"
      aria-label={$_('aria.sync_now')}
    >
      <RefreshCw class="w-4 h-4" />
    </Button>
  {/if}
</div>

<style>
  /* Optional custom styles */
</style>
